/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("CanvasPolygonController", ["ControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class CanvasPolygonController
   * @memberOf classes
   * @extends classes.ControllerBase
   */
  class CanvasPolygonController extends cls.ControllerBase /** @lends classes.CanvasPolygonController.prototype */ {
    static __name = "CanvasPolygonController";

    _initBehaviors() {
      super._initBehaviors();

      this._addBehavior(cls.CanvasPolygonParametersVMBehavior);
      this._addBehavior(cls.CanvasFillColorVMBehavior);
      this._addBehavior(cls.CanvasItemOnClickUIBehavior);
    }
  }

  cls.CanvasPolygonController = CanvasPolygonController;
  cls.ControllerFactory.register("CanvasPolygon", cls.CanvasPolygonController);
});
